module.exports = __webpack_public_path__ + "static/media/Timer_HBT.01338866.svg";